<pm-analysis-configuration-summary [summary]="summary()" />
